import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import Button from 'desktop/components/Button';

export const SidebarStyled = styled.div`
  width: 350px;
  padding: 28px 8px 0 40px;
  height: 100%;
  box-sizing: border-box;
`;

export const ChannelsWrap = styled.div`
  position: relative;
`;

export const AllChannels = styled.div`
  margin-bottom: 27px;
  font-size: 0;
`;

export const StyledButton = styled(Button)`
  transform: translate(-2px, 0);
`;

export const ContentLoaderStyled = styled(ContentLoader)`
  margin-bottom: 20px;
  height: 38.5px;
`;
